import { createContext, useContext } from 'react';

export const DataContext = createContext({});

export function useDataContextValue() {
  return useContext(DataContext);
}
